import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from "@angular/router";
import { SlotReleaseCalendarService } from 'src/app/services/slot-release-calendar.service';
import { AlertService } from 'src/app/services/alerts.service';
import { MediaOrdersService } from 'src/app/services/media-orders.service';

@Component({
  selector: 'app-confirm-import-modal',
  templateUrl: './confirm-import-modal.component.html',
  styleUrls: ['./confirm-import-modal.component.css'],
})
export class ConfirmImportModalComponent {

  @Input() games: Array<any>;
  @Input() buttonText: string;
  @Input() size: 'sm' | 'xs' = 'sm';

  @Output()
  onCloseAfterUpdateEvent = new EventEmitter<any>();

  @ViewChild('content')
  content: ElementRef;

  gameUpdated: boolean = false;
  importDone: boolean = false;
  isSaving: boolean = false;
  importedIds: Array<any> = [];
  importedGames: Array<any> = [];
  alreadyExistingGames: Array<any> = [];
  notFoundManufacturers: Array<any> = [];

  constructor(
      private router: Router,
      private slotReleaseCalendarService: SlotReleaseCalendarService,
      private alertService: AlertService,
      private mediaOrdersService: MediaOrdersService,
      private modalService: NgbModal
  ) {}

  open() {
    this.gameUpdated = false;
    this.importDone = false;
    this.isSaving = false;
    this.importedIds = [];
    this.importedGames = [];
    this.alreadyExistingGames = [];
    this.notFoundManufacturers = [];
    let callback = (result: any) => {
      if (this.gameUpdated) {
        this.onCloseAfterUpdateEvent.emit();
      }
    }

    this.modalService.open(this.content, { size: 'md' }).result.then(callback, callback);
  }

  onButtonClick(event: Event) {
    event.stopPropagation();
    this.open();
  }

  onSave() {
    const thisComponent = this;

    this.isSaving = true;
    this.slotReleaseCalendarService.importUpcomingGames(this.games).subscribe({
        next(response) {
          thisComponent.isSaving = false;
          thisComponent.importDone = true;
          thisComponent.importedIds = response.importedIds;
          thisComponent.importedGames = response.importedGames || [];
          thisComponent.alreadyExistingGames = response.alreadyExistingGames || [];
          thisComponent.notFoundManufacturers = response.notFoundManufacturers;
          // list is reloaded on modal close - reloading now would destroy this row's component mid media order creation
          thisComponent.gameUpdated = true;
          thisComponent.createMediaOrders();
        },
        error(error) {
          thisComponent.isSaving = false;
          if (error.status === 403) {
            thisComponent.alertService.alertError('Permission denied. You do not have access to perform this action.');
          } else {
            console.error('An error occurred:', error);
            thisComponent.alertService.alertError('Failed to import games: ' + (error.error?.error?.message || error.error?.error || error.message));
          }
        }
      });
  }

  // same as when a game request is set to "fulfilled" - the game is known to exist, so media can be ordered right away
  async createMediaOrders() {
    for (const game of this.importedGames) {
      game.media_order_status = 'creating';
      try {
        const res: any = await this.mediaOrdersService.createOrUpdateMediaOrder('cdb', 'new_games', game.game_id);
        game.media_order_id = res.data.media_order.id;
        game.media_order_status = 'created';
      } catch (e) {
        console.error(e);
        game.media_order_status = 'failed';
      }
    }
  }

  onClose() {
    this.modalService.dismissAll();
  }
}
